<template>
  <ul :class="size?'pagination--'+size:''" class="pagination">
    <li :class="{'pagination__item--disabled':current$ === 1}" class="pagination__item pagination__item--previous">
      <span class="pagination__item-link" @click.stop="$_onPrevSpanClick()"></span>
    </li>
    <template v-if="simple === false">
      <li v-for="(page,index) in pagination" :key="'t-pager-'+index"
          :class="[{'pagination__item--active': page > 0 && current$ === page},
                   {'pagination__item--jump' : page < 0}]"
          class="pagination__item"
          @mouseenter="quickIconDirect = page"
          @mouseleave="quickIconDirect = ''">
        <a v-if="page < 0 "
           :class="[{'pagination__item-link-prev': quickIconDirect === -1 && page === -1}, {'pagination__item-link-next': quickIconDirect === -2 && page === -2}]"
           class="pagination__item-link"
           @click.stop="$_onJumpPage(page)"></a>
        <a v-else
           class="pagination__item-link"
           href="javascript:void(0)"
           @click.stop="$_onAClick(page)">{{ page }}</a>
      </li>
    </template>
    <li :class="{'pagination__item--disabled':current$ === amount}" class="pagination__item pagination__item--next">
      <a class="pagination__item-link" @click.stop="$_onNextAClick()"></a>
    </li>
    <li v-if="hasOption" class="pagination__options" >
      <sizer v-if="showSizer" :page-size="pageSize$" :range="sizerRange$" @on-change="$_onSizerChange"></sizer>
      <elevator v-if="showElevator" ref="elevator" :current="current$" @on-change="$_onAClick"></elevator>
    </li>
  </ul>
</template>
<script>
import sizer from './sizer.vue'
import elevator from './elevator.vue'
import { isPInt } from '../../utils/assist'

const THRESHOLD = 7

export default {
  name: 'TPager',
  components: {
    sizer,
    elevator
  },
  props: {
    total: {
      type: Number,
      validator: value => isPInt(value),
      default: 0
    },
    pageSize: {
      type: Number,
      validator: value => isPInt(value) && value > 0,
      default: 5
    },
    sizerRange: {
      type: Array,
      default() {
        return null
      }
    },
    current: {
      type: Number,
      validator: value => isPInt(value) && value > 0,
      default: 1
    },
    size: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'sm', 'lg'].indexOf(value) > -1
      }
    },
    simple: {
      type: Boolean,
      default: false
    },
    showElevator: {
      type: Boolean,
      default: false
    },
    showSizer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current$: this.current,
      pageSize$: this.pageSize,
      sizerRange$: (this.sizerRange && this.sizerRange) || [5, 10, 20, 30],
      quickIconDirect: ''
    }
  },
  computed: {
    hasOption() {
      return this.showSizer || this.showElevator
    },
    amount() {
      return Math.ceil(this.total / this.pageSize$)
    },
    pagination() {
      const current = this.current$
      const pageCount = this.amount
      let _pagination = []
      let showPrevMore = false
      let showNextMore = false
      if (pageCount > THRESHOLD) {
        // 如果总页数超过限定的页数，需要加跳转按钮
        if (current > THRESHOLD - 3) {
          showPrevMore = true
        }
        if (current < pageCount - 3) {
          showNextMore = true
        }
      }
      let [start, end] = [1, pageCount]
      if (showPrevMore && showNextMore) {
        const offset = Math.floor(THRESHOLD / 2) - 1
        _pagination.push(1)
        _pagination.push(-1)
        start = current - offset
        end = current + offset
      } else if (!showPrevMore && showNextMore) {
        start = 1
        end = THRESHOLD + 1
      } else if (showPrevMore && !showNextMore) {
        _pagination.push(1)
        _pagination.push(-1)
        start = pageCount - (THRESHOLD - 2)
        end = pageCount
      } else {
        start = 1
        end = pageCount
      }
      for (let i = start; i <= end; i++) {
        _pagination.push(i)
      }
      if (showPrevMore) {
        _pagination.splice(1, 1, -1)
      }
      if (showNextMore) {
        if (!showPrevMore) {
          _pagination.splice(-2, 1, -2)
          _pagination.splice(-1, 1, pageCount)
        } else {
          _pagination.push(-2)
          _pagination.push(pageCount)
        }
      }
      return _pagination
    }
  },
  watch: {
    current(val) {
      if (this.amount < val || val < 1) {
        this.$emit('update:current', this.current$)
      } else {
        this.$_onAClick(val)
      }
    },
    pageSize(val) {
      this.pageSize$ = this.$_getPageSize(val)
    },
    pageSize$(val) {
      if (val !== this.pageSize) {
        this.$emit('update:pageSize', val)
      }
    },
    current$(val) {
      if (this.$refs.elevator && this.$refs.elevator.page$) {
        this.$refs.elevator.page$ = val
      }
      if (val !== this.current) {
        this.$emit('update:current', val)
      }
      this.$emit('on-change', val)
    },
    sizerRange(newVal, oldVal) {
      if ((newVal && oldVal && newVal.toString() !== oldVal.toString()) || (newVal && !oldVal)) {
        this.sizerRange$ = newVal
      }
    },
    amount(val) {
      if (this.current$ > val) {
        this.current$ = 1
      }
    }
  },
  created() {
    if (this.amount < this.current || this.current < 1) {
      this.current$ = 1
    }
    this.pageSize$ = this.$_getPageSize()
  },
  methods: {
    // 设置私有方法
    $_onAClick(page) {
      if (this.amount < page || page < 1) {
        page = this.current$ || this.amount
        if (this.$refs.elevator && this.$refs.elevator.page$) {
          this.$refs.elevator.page$ = page
        }
      } else {
        this.current$ = page
      }
    },
    $_onPrevSpanClick() {
      if (this.current$ <= 1) return false
      this.$_onAClick(this.current$ - 1)
    },
    $_onNextAClick() {
      if (this.current$ >= this.amount) return false
      this.$_onAClick(this.current$ + 1)
    },
    $_onSizerChange(pageSize) {
      this.pageSize$ = pageSize
      this.$emit('on-size-change', pageSize)
      this.$_onAClick(1)
      this.$refs.elevator && this.$refs.elevator.gotoFirst()
    },
    $_onJumpPage(direct) {
      if (direct === -1) {
        // 向前翻页
        let _page = this.current$ - 5
        this.current$ = _page < 1 ? 1 : _page
      } else if (direct === -2) {
        // 向后翻页
        let _page = this.current$ + 5
        this.current$ = _page > this.amount ? this.amount : _page
      }
    },
    $_getPageSize(pageSize = this.pageSize) {
      if (this.sizerRange && this.sizerRange[0]) {
        return this.sizerRange.includes(pageSize) ? pageSize : this.sizerRange[0]
      } else {
        if (this.showSizer) {
          return this.sizerRange$.includes(pageSize) ? pageSize : this.sizerRange$[0]
        } else {
          return pageSize
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// pager.vue?256ff253